import React, { useState, useEffect } from "react";
import Breadcrumb from "../../../../../../components/Breadcrum";
import { ArrowRight } from "lucide-react";
import "./Apricots.css";

export default function Apricots() {
    const apricotProducts = [
        {
            id: 1,
            name: "DRIED APRICOTS",
            image: "/assets/img/Apricots/Dried-Apricots.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Healthy snack products",
                        "Bakery applications",
                        "Breakfast cereals",
                        "Premium dry fruit packs",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Naturally sweet flavor",
                        "Rich in fiber and nutrients",
                        "Long shelf life",
                        "Popular healthy snack",
                    ],
                },
            ],
        },

        {
            id: 2,
            name: "SULPHURED APRICOTS",
            image: "/assets/img/Apricots/Sulphured-Apricots.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Food processing industries",
                        "Bakery products",
                        "Retail packaging",
                        "Snack manufacturing",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Bright attractive color",
                        "Extended shelf life",
                        "Consistent quality",
                        "Widely used commercially",
                    ],
                },
            ],
        },

        {
            id: 3,
            name: "ORGANIC APRICOTS",
            image: "/assets/img/Apricots/Organic-Apricots.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Organic food products",
                        "Health food stores",
                        "Nutrition plans",
                        "Premium snack packs",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Chemical-free cultivation",
                        "Natural taste and texture",
                        "High nutritional value",
                        "Growing consumer demand",
                    ],
                },
            ],
        },
    ];

    const defaultImage =
        "https://upload.wikimedia.org/wikipedia/commons/7/79/Polypropylene_%28PP%29_Granules.jpg";

    const [selectedProduct, setSelectedProduct] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Breadcrumb
                title="Apricots"
                backgroundImage="./assets/img/contact-banner.png"
                height="40vh"
            />

            <section className="pp-section">
                <div className="container">
                    <h1 className="pp-title">Apricots Product Range</h1>

                    <p className="pp-subtitle">
                        Explore our premium quality Apricots sourced from trusted suppliers
                        worldwide.
                    </p>

                    <div className="pp-grid">
                        {apricotProducts.map((product) => (
                            <div className="pp-card" key={product.id}>
                                <div className="pp-img-box">
                                    <img
                                        src={product.image || defaultImage}
                                        alt={product.name}
                                        onError={(e) => (e.target.src = defaultImage)}
                                    />
                                </div>

                                <div className="pp-info">
                                    <h2 className="pp-name">{product.name}</h2>

                                    <button
                                        className="view-btn"
                                        onClick={() => setSelectedProduct(product)}
                                    >
                                        View Details <ArrowRight size={16} />
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>

                    {selectedProduct && (
                        <div
                            className="modal-overlay"
                            onClick={() => setSelectedProduct(null)}
                        >
                            <div
                                className="modal-content"
                                onClick={(e) => e.stopPropagation()}
                            >
                                <img
                                    src={selectedProduct.image || defaultImage}
                                    alt={selectedProduct.name}
                                    className="modal-image"
                                />

                                <h2 className="modal-title">{selectedProduct.name}</h2>

                                <div className="usage-section">
                                    {selectedProduct.usage.map((section, index) => (
                                        <div key={index} className="usage-block">
                                            <h3>{section.title}</h3>

                                            <ul>
                                                {section.points.map((point, i) => (
                                                    <li key={i}>{point}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    ))}
                                </div>

                                <button
                                    className="close-btn"
                                    onClick={() => setSelectedProduct(null)}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </section>
        </>
    );
}